"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = deriveLightDark;

var _colorManipulator = require("@material-ui/core/styles/colorManipulator");

var _normalizeColor = _interopRequireDefault(require("./normalizeColor"));

var _readableColor = _interopRequireDefault(require("./readableColor"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// TODO: figure out how to get this from the theme
var tonalOffset = 0.2;
/**
 * creates an object with `main`, `light`, and `dark` colors.
 */

function deriveLightDark(color) {
  return {
    main: color,
    light: (0, _normalizeColor["default"])((0, _colorManipulator.lighten)(color, tonalOffset)),
    dark: (0, _normalizeColor["default"])((0, _colorManipulator.darken)(color, tonalOffset * 1.5)),
    contrastText: (0, _normalizeColor["default"])((0, _readableColor["default"])(color))
  };
}